var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n    ")]),_vm._v(" "),_c('el-divider',{attrs:{"id":"divider2"}}),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("\n    "+_vm._s(_vm.msg1)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dfed8d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/divider1.vue
// module id = null
// module chunks = 